import React, { useContext, useEffect, useState } from 'react'
import { ContainerNew } from 'presentation/shared/components/ContainerNew'
import { useHistory, useLocation } from 'react-router'
import HeaderNew from 'presentation/shared/components/HeaderNew'

import { AmbulatoryAuthorizationDashboardContext } from 'main/factories/pages/doctor/ambulatory-authorization/ambulatory-authorization-dashboard-factory'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import { useFormik } from 'formik'
import SelectFieldNew from 'presentation/shared/components/SelectFieldNew'

import { useServices } from 'presentation/hooks/use-services'
import { toast } from 'react-toastify'
import {
  WithLoading,
  WithLoadingProps
} from 'presentation/shared/components/HOCs/WithLoading'
import { HospitalNew } from 'domain/entities/hospital-model-new'
import { validationSchema } from './validationSchema'
import * as S from './styles'

type LocationProps = {
  isEditing?: boolean
}

export const AmbulatoryUnitLayout = WithLoading(
  ({ setIsLoading }: WithLoadingProps) => {
    const history = useHistory()
    const stateLocation = useLocation()?.state as LocationProps
    const { state, dispatch } = useContext<any>(
      AmbulatoryAuthorizationDashboardContext
    )
    const { patient, unit } = state

    if (!patient?.cpf) {
      history.push('/pedidos-autorizacao-ambulatorial/solicitacao')
    }

    const hospitalService = useServices().hospital
    const [hospitals, setHospitals] = useState<HospitalNew[]>([])

    const formik = useFormik({
      initialValues: {
        unit: unit?.hospital_id || ''
      },
      validationSchema: validationSchema,
      validateOnMount: true,
      onSubmit: async (values) => {
        const unit = hospitals.find(
          (hospital) => hospital.hospital_id === Number(values.unit)
        )
        dispatch({
          type: 'UNIT_INFO',
          payload: unit
        })
        stateLocation?.isEditing
          ? history.push('resumo#unid')
          : history.push('procedimentos')
      }
    }) as any

    const loadHospitalsByDoctor = async () => {
      try {
        setIsLoading(true)
        const loadHospitals = await hospitalService.loadHospitalsByDoctor()
        setHospitals(loadHospitals)
      } catch (error: any) {
        toast.error('Ocorreu um erro ao buscar as unidades')
      } finally {
        setIsLoading(false)
      }
    }

    useEffect(() => {
      loadHospitalsByDoctor()
    }, [])

    return (
      <>
        <HeaderNew
          actualPageOnClick={() =>
            stateLocation?.isEditing ? history.push('resumo') : history.goBack()
          }
          actualPageTitle="Solicitar pedido ambulatorial"
        />

        <ContainerNew
          title="Unidade"
          titleColor="neutral800"
          titleSize="large"
          titleWeight="bold"
          // style={{ paddingBottom: 0 }}
          primaryButton={
            <ButtonNew
              fullWidth
              size="large"
              onClick={formik.submitForm}
              disabled={formik.isSubmitting || !formik.isValid}
            >
              {stateLocation?.isEditing ? 'Salvar' : 'Próximo'}
            </ButtonNew>
          }
        >
          <S.Wrapper>
            <S.FormWrapper onSubmit={formik.handleSubmit}>
              <SelectFieldNew
                labelOverlapping
                labelWeight="semiBold"
                labelSize="xxsmall"
                labelColor="neutral700"
                label="Unidade "
                name="unit"
                items={hospitals?.map(
                  ({ name, friendly_name, hospital_id }) => ({
                    label: friendly_name ?? name,
                    value: hospital_id
                  })
                )}
                onChange={formik.handleChange}
                value={formik.values.unit}
                error={formik.touched.unit && formik.errors.unit}
                required
                requiredColor="neutral800"
              />
            </S.FormWrapper>
          </S.Wrapper>
        </ContainerNew>
      </>
    )
  }
)

export default AmbulatoryUnitLayout
